import $ from 'jquery';
import 'what-input';

// for babel / Promises use: ref: https://github.com/babel/babel/issues/9853
// see the following for other options: https://github.com/zloirock/core-js/blob/master/docs/2019-03-19-core-js-3-babel-and-a-look-into-the-future.md
import 'core-js-pure/stable/promise';
import * as cookies from "./utilities/cookies";
import * as u from "./utilities/general";
import FetchHelpers from "./fetch-helpers";
import {itemsPerPageHandler, setCollectionOptions} from "./pagination";
import {setOptionValues} from "./account/annotations";
import {addPinEventHandlers} from "./account/last-locations";
import {getCurrentFontSizeOnClient, storeFontSizeToStorages} from "./font-size";
import {getCookie, setCookie} from "./utilities/cookies";

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.

window.jQuery = $;
require('foundation-sites');

// Initialise all foundation plugins within the main-nav
//$('#main-nav').foundation();

// Foundation plugins must be initialised after DOM is done loading
$(document).foundation();

// Foundation now loaded in, let hover appearance work on the menu again
let mainNav = document.querySelector('#main-nav');
if (mainNav) {
  mainNav.classList.remove('foundation-loading');
}

/**
 * Run all necessary JS after page loads
 */
document.addEventListener('DOMContentLoaded', () => {
  // if we signed in automatically, enable the Sign-out button
  handleEnablingSignInButton();

  const userPreferences = u.userPreferences();
  let au = false;
  if (Object.keys(userPreferences).length > 0) {
    au = userPreferences.au === 'true';
  }

  // Pagination items-per-page selector:
  //  - pass in the collection class, possibly from the items-per-page element (it should
  //  - know what collection it belongs to)
  const itemsSelect = document.querySelector('.items-per-page');
  if(itemsSelect) {
    itemsSelect.addEventListener('change', (event) => {
      let { target, target: { id } } = event;
      let targetSelector = `#${id}`;
      let { dataset } = target;
      const paginatorName = dataset.paginatorName;

      let options = setOptionValues();
      options.spinner = {
        targetSelector,
        insertPosition: 'beforebegin',
      }

      // options for updating the collection
      let hasPins, isEditable;

      if(paginatorName === 'last-locations') {
        hasPins = true;
        isEditable = true;
      } else {
        hasPins = false;
        isEditable = true;
      }

      // set up options
      options = setCollectionOptions(options, paginatorName, hasPins, isEditable);
      itemsPerPageHandler(event, options)
        .then(() => {
          // re-wire pin event handler
          if (options.collection.hasPins ?? false) {
            addPinEventHandlers();
          }
        });
    })
  }

  const updateModal = $('#recent-updates');
  if(updateModal.length > 0) {
    let hideUpdateModal = true; // default to hide

    // fetch their update modal visibility selection
    if (au) {
      hideUpdateModal = userPreferences.HideUpdateModal ?? true;
    }

    // Display modal
    if (au && !hideUpdateModal) {
      updateModal.foundation('open');
    }
  }

  // click handler for updates modal 'Dismiss and close' button
  let hideUpdatesBtn = document.querySelector('#hide-updates');
  if(hideUpdatesBtn) {
    hideUpdatesBtn.style.display = 'inline-block';
    hideUpdatesBtn.addEventListener('click', (event) => {
      recentUpdatesPopupHandler(updateModal[0].id, 'HideUpdateModal', true, event);
    });
  }

  let updatesBtn = document.querySelector("[data-open='quick-tour']");
  if(updatesBtn) {
    let btn = document.querySelector('#hide-tour');
    updatesBtn.addEventListener('click', hideUpdatesPopupButton.bind(btn));
  }

  const tourModal = $('#quick-tour');
  const now = new Date();
  const launchCampaignEnded = now > new Date('July 22, 2022 12:00:00'); // 7/21/22 at noon, one day after launch end

  const tourPopupCookieValue = cookies.getCookie('showQuickTourPopUp');
  const showPopUp = !launchCampaignEnded && !(tourPopupCookieValue === 'false');
  // the Quick tour popup is also on the help page
  const notOnHelpPage = !window.location.pathname.includes('help');
  // the Quick tour popup is also on the account/profile page
  const notOnProfilePage = !window.location.pathname.includes('account')

  // if the tour modal is on the page and there is no tour cookie set
  if(tourModal && showPopUp && notOnHelpPage && notOnProfilePage) {
    tourModal.foundation('open');
  }

  // click handler for tour video 'do-not-open-by-default' button
  let hideTourBtn = document.querySelector('#hide-tour');
  if(hideTourBtn) {
    hideTourBtn.style.display = 'inline-block';
    hideTourBtn.addEventListener('click', () => {
      quickTourPopupHandler(tourModal);
    });
  }

  const tourBtn = document.querySelector("[data-open='quick-tour']");
  if(tourBtn) {
    tourBtn.addEventListener('click', hideDoNotOpenButton);
  }

  const lsmSearchOutlineBtn = document.querySelector("[data-submit='lsm-outlines']");
  if(lsmSearchOutlineBtn) {
    lsmSearchOutlineBtn.addEventListener('click', function (e) {
      e.preventDefault();
      searchOutlinesButton(e);
    });
    lsmSearchOutlineBtn.addEventListener('submit', function (e) {
      e.preventDefault();
      searchOutlinesButton(e);
    });
  }

  /** Discount Available Notice - Remember user selection to not show discount available notice on dashboard **/
  const discount_notice = document.querySelector('#discount-notice');
  if(discount_notice) {
    // add event handler to close button on notice
    discount_notice
      .querySelector('.close-button')
      .addEventListener('click', (event) => {
        saveModalUserSelectionHandler(event, [discount_notice[0].id, 'hideDiscountModal']);
      })
  }

  // Clear sessionStorage on Sign-out
  const signOutBtn = document.querySelector('#sign-out');
  if(signOutBtn) {
    signOutBtn.addEventListener('click', () => { sessionStorage.clear() })
  }

  $('body').prepend('<a href="#" class="back-to-top"><span class="show-for-sr">Back to Top</span></a>');
  const amountScrolled = 300;
  $(window).scroll(function()
  {	if ( $(window).scrollTop() > amountScrolled )
  {$('a.back-to-top').fadeIn('slow');}
  else
  {$('a.back-to-top').fadeOut('slow');}
  });
  $('a.back-to-top').click(function()
  {$('body, html').animate({scrollTop: 0}, 700);return false;});

  // set session variable after initial sign-in load
  initializationsOnInitialLogin();
});

/**
 * Handle click on password visibility 'eye' button
 */
document.querySelectorAll(".toggle-password").forEach(element => {
  element.addEventListener("click", function () {
    // Switch on and off
    element.classList.toggle("fa-eye-slash");
    element.classList.toggle("fa-eye");

    let input = this.previousElementSibling;
    if (input.type === "password") {
      input.type = "text";
    } else {
      input.type = "password";
    }
  })
});

window.addEventListener('scroll', function () {
  // Add padding so top of content is not hidden behind sticky nav
  const sticky_wrapper = document.getElementById("sticky-wrapper");
  const content_wrapper = document.getElementById("content-wrapper");
  if(sticky_wrapper) {
    const is_stuck = sticky_wrapper.classList.contains("is-stuck");
    if (is_stuck) {
      content_wrapper.style.paddingTop = (1 + sticky_wrapper.offsetHeight) + "px";
    } else {
      content_wrapper.style.paddingTop = "";
    }
  }
});

/**
 * save user option to dismiss a modal, so it doesn't show anymore.
 *
 * If the user closes the notice, it will not be displayed again on the dashboard and neither will
 * the user icon next to the username.
 * We also remove the user icon next to the username.
 */
function saveModalUserSelectionHandler(event, options) {
  const element = options[0];
  const selection = options[1];
  let url, data;
  if(selection === 'hideDiscountModal') {
    data = {'hideDiscountNotice': true}
    url = element.dataset.updateUrl;
  }

  if(selection === 'HideUpdateModal') {
    data = {'HideUpdateModal': true}
    url = element.dataset.updateUrl;
  }

  new FetchHelpers().fetchData('POST', url, data)
    .then( (result) => {
      if(result.success) {
        console.log(result.message);
        document.querySelector('#user-notification-icon').style.display = 'none';
      }
    });
}

/**
 * Get the difference in days between two dates (javascript Date objects).
 *
 * @param a Date object
 * @param b Date object
 * @returns {number}
 */
function dateDiffInDays(a, b) {
  const _MS_PER_DAY = 1000 * 60 * 60 * 24;

  // discard the time and time-zone info
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

  return Math.floor((utc2 - utc1) / _MS_PER_DAY);
}

/**
 * Handler Recent Updates 'do not show again' button.
 * Keep cookie around when set for a year; we should definitely have at least 1 release every year.
 */
function recentUpdatesPopupHandler(elementId, cookieName, option, event) {
  event.preventDefault();

  // Remember user selection to not show recent updates notice
  const modal = document.querySelector(`#${elementId}`);
  if(modal) {
    const data = {'HideUpdateModal': true}
    const url = modal.dataset.updateUrl;
    new FetchHelpers().fetchData('POST', url, data)
      .then((result) => {
        if(result.success) {
          console.log("Updated 'HideUpdateModal' user selection.");
        } else {
          console.log("Could not update 'HideUpdateModal' user selection.");
        }
      });
  }

  $(`#${elementId}`).foundation('close');
}

/**
 * Click handler to hide do-not-open-by-default when popup opened from Quick Tour button and not default open
 * @param btn
 */
function hideUpdatesPopupButton(btn) {
  btn.style.display = 'none';
}

/**
 * Handler for quick tour 'do not show again' button.
 */
function quickTourPopupHandler(tourModal) {
  event.preventDefault();

  const now = new Date();
  const launchCampaignEnd = new Date('July 22, 2022 12:00:00'); // 7/21/22 at noon, one day after launch end
  const daysToLive = dateDiffInDays(now, launchCampaignEnd);

  cookies.setCookie('showQuickTourPopUp', false, daysToLive);

  tourModal.foundation('close');
}

/**
 * Click handler to hide do-not-open-by-default when popup opened from Quick Tour button and not default open
 */
function hideDoNotOpenButton() {
  let btn = document.querySelector('#hide-tour');
  btn.style.display = 'none';
}

/**
 * Search LSM outlines form, on help page
 */
function searchOutlinesButton() {
  const lsmSearchForm = document.getElementById('search_lsm_outlines_form');
  const lsmSearchInput = document.getElementById('search_lsm_outlines_q').value;
  if (lsmSearchInput !== '') {
    lsmSearchForm.action = "https://www.lsm.org/search.html?#gsc.tab=0&gsc.ref=more%3Aoutlines&gsc.q=" + lsmSearchInput;
    lsmSearchForm.submit();
  }
}

/**
 * Enable the sign-out button once the user is signed in
 */
function handleEnablingSignInButton() {
  const userNameElem = document.querySelector('.username');
  if(userNameElem) {
    const signOutElem = document.querySelector('#sign-out');
    if (signOutElem) {
      signOutElem.removeAttribute('disabled');
    }
  }
}

function initializationsOnInitialLogin() {
  const userNameElem = document.querySelector('.username');
  if(userNameElem) {
   setCookie('loginInitialized', 'true');
  }
}

/** check footer.php for other JS used... **/
